import { createSlice } from "@reduxjs/toolkit";

const initialLevelSection = {
  name: "",
  capacity: 1,
  courses: []
}

const initialLevelSectionsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null,
  levelSection: initialLevelSection
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const levelSectionSlice = createSlice({
  name: "levelSections",
  initialState: initialLevelSectionsState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getLevelSections
    levelSectionsFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
    },    
    // getCourses
    coursesFetched: (state, action) => {
      const { isSuccess, type, entities } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.courses = entities;
    },
    //getLevelSection
    levelSectionFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.levelSection = action.payload.entity;
    },
    //completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    //cleanLevelSectionsState
    levelSectionsStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.totalCount = 0;
      state.entities = [];
      state.levelSection = initialLevelSection;
    }
  }
});